module.exports = __webpack_public_path__ + "static/img/gif6.b57b5879.gif";